import React from "react";
import {useHistory} from "react-router";



function SuccessMessage (props:any) {
    const history = useHistory();

    return (
        <div className="successMessage w-full" >
        <div className="title">Reset Your Password</div>
        <div className="subTitle" style={{marginTop:"10px"}}>Your password update was successful 🙌. Please log in using your new password.</div>
        <div style={{marginTop: "40px"}} >
            <button onClick={() => history.push('/signin/email-signIn')} className='submitBtn' >Login Now</button>
        </div>
    </div>
    )

}

export default SuccessMessage;